/* ===========================================================================
   Site content.

   Copy is Intelligence Lab's own, reproduced from intelligencelabjo.com in
   full. The single edit is to the hero paragraph, which on the reference opens
   as a sentence fragment continuing the headline across a full stop
   ("Intelligence Lab." / "is a team of experts…").

   The course descriptions keep their closing age sentence verbatim; the age
   chip on each card surfaces the same fact as a scannable label.
   =========================================================================== */

/* The reference ships exactly these two in-page links. */
export const NAV_ITEMS = [
  { label: "Main", href: "#main" },
  { label: "Courses", href: "#courses" },
];

export const HERO = {
  eyebrow: "Robotics · Programming · App development",
  titleLead: "Intelligence",
  titleTail: "Lab.",
  lede: "A team of experts, determined to empower young people for a prosperous future. We truly believe in the power of quality education and scientific skillset to build a futureproof career for our next generations. By following a practical teaching methodology, we introduce children and teenagers to the world of robotics, app development, programming, and other similar areas.",
  quote: {
    kicker: "Tomorrow is our",
    title: "“When I Grow Up” Spirit Day!",
  },
};

export const PURPOSE = [
  {
    id: "vision",
    icon: "vision",
    title: "Our Vision",
    body: "To make quality scientific education widely accessible to young people so they can harness and lead future technological innovations in a socially responsible manner.",
  },
  {
    id: "mission",
    icon: "mission",
    title: "Our Mission",
    body: "To provide expert mentorship to children and teenagers in the field of technology so they can develop a solid foundation and life-long interest for scientific research and study.",
  },
];

export const COURSES = [
  {
    id: "ev3",
    title: "EV3 Robotics",
    ages: "Ages 11–16",
    lessons: 25,
    rating: 4.5,
    reviews: 44,
    image: "course-ev3",
    alt: "Two Intelligence Lab students assembling an EV3 robot together",
    body: "This course introduces to analytical thinking and problem solving using robotics. The EV3 Core Set, robotics kit, is used to make functional robots with motors, sensors, and electrical connections. It is targeted for students aged 11-16 years.",
  },
  {
    id: "wedo",
    title: "WeDo 2.0 Robotics",
    ages: "Ages 6–10",
    lessons: 25,
    rating: 4.5,
    reviews: 44,
    image: "course-wedo",
    alt: "A young student sorting parts from a WeDo 2.0 robotics kit",
    body: "The purpose of this course is similar to that of EV3 Robotics – problem solving using robots. However, the content is especially tailored for younger students in the age group of 6-10 years.",
  },
  {
    id: "android",
    title: "Android Programming",
    ages: "Ages 11–16",
    lessons: 25,
    rating: 4.5,
    reviews: 44,
    image: "course-android",
    alt: "A student building an app with MIT App Inventor on a laptop",
    body: "We use MIT App Inventor to teach programming and functional application development using a user-friendly graphic interface. The idea is to give students an intuitive sense behind computer logic of executing commands. The course is targeted for students aged 11-16 years.",
  },
];

/* The reference runs this same line under both the course grid and the
   statistics; reproduced in both places. */
export const PROUD_LEDE =
  "You don't have to struggle alone, you've got our assistance and help.";

export const STATS = [
  { id: "curricula", icon: "curricula", value: 3, label: "Curricula", tone: "pink" },
  { id: "books", icon: "books", value: 25, label: "Copies of each book", tone: "orange" },
  { id: "hours", icon: "hours", value: 100, label: "Hours of training", tone: "cyan" },
];

/* The reference panel is a headline with nothing to act on — its button is
   commented out in the source, pointing at a contact page that does not ship.
   The button is restored here aimed at the course list, which does exist. */
export const CTA = {
  title: "Ready to learn?",
  action: { label: "See the courses", href: "#courses" },
};

export const FOOTER = {
  copyright: "© 2022 Intelligence Lab, All Rights Reserved.",
};
